import React, { useState, useEffect, useCallback,useMemo } from "react";
import {
  Modal,
  Dropdown,
  Input,
  Form,
  Button,
  Icon,
  Dimmer,
  Loader,
} from "semantic-ui-react";
import * as auth from "../../modules/Auth/_redux/authRedux";
import search_icon from "../../../Assets/Icons/search-icon.svg";

import { getCountryByName } from "country-state-city";

import { Map, Marker } from "google-maps-react";

import MapMarker from "./map-marker";

import GeofenceMarker from "./geofence-marker";
import { useSuccessModal } from "../../../hooks/Messages/useSuccessModal";

import CustomMarkerIcon from "../../../Assets/Icons/marker.svg";

import { Country, State } from "country-state-city";
import { connect, useDispatch, useSelector } from "react-redux";
import { LetteredAvatarImageUrl } from "../../components/common/userProfilePlaceholder";
import { toast } from "react-toastify";
import { selectTranslations } from "../../config/i18n/slice";
import { scrollToError } from "../../../utilFunctions/scrollToError";
import {
  AddIconWithCircle,
  CloseIcon,
  CustomerPlusIcon,
  DeleteIcon,
  GreenLocationIcon,
  ImgPhotos,
  Mp4File,
  PngPhotos,
  Success,
  TextSnippet,
} from "../../../Assets/Icons/svg";
import Asterisk from "../../components/common/Asterisk";
import { cloneDeep, debounce } from "lodash";
import { extractAddress } from "../../../services/extractAddress";
import { useDropzone } from "react-dropzone";
import ToolTip from "react-power-tooltip";
import {
  fetchAllLoctionData,
  fetchLocations,
} from "../../../redux/reducers/locationReducer";
import { Resizable } from "re-resizable";
import useNewCancelModal from "../../../hooks/Messages/useNewCncelModal";
import { getAllCustomers } from "../../config/sharedApi/customerApis";
import { createNewLocation, getParentBySubLoc } from "../../config/api/locationApis";
import {
  getAllParentLocations,
  updateGeofencingCoords,
  updateMainLocation,
} from "../../config/sharedApi/locationApis";
import { getAllVendros } from "../../config/sharedApi/vendorApis";
import { uploadFile } from "../../config/api/configApis";
import { getUserData } from "../../config/sharedApi/peopleApis";
import {
  buildLocationValidation,
  makeOnBlurFactory,
  makeOnValuesChangeFactory,
  makeValidateOnSubmitFactory,
} from "./locationValidationRules";


const FileUpload = ({
  onFileChange,
  name = "",
  attachments = {},
  setAttachments = () => {},
}) => {
  const fileTypes = {
    images: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/gif",
      "image/svg+xml",
      "image/webp",
      "image/heic",
    ],
    documents: [
      "text/plain",
      "application/pdf",
      "text/csv",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ],
    video: ["video/mp4", "video/quicktime", "video/webm", "video/hevc"],
  };
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      const allowedFileTypes = [...fileTypes.images];

      const invalidFiles = acceptedFiles.filter(
        (file) => !allowedFileTypes.includes(file.type)
      );

      if (invalidFiles?.length > 0) {
        toast.error(t.common.invalid_msg);
        return;
      }
      let totalSize = organisationImage?.attachmentsSize
        ? organisationImage?.attachmentsSize
        : 200;
      const validFiles = acceptedFiles.filter((file) => {
        const isImage = fileTypes.images.includes(file.type);
        const isDocument = fileTypes.documents.includes(file.type);

        const isVideo = fileTypes.video.includes(file.type);

        const validSize =
          (isVideo || isImage || isDocument) &&
          file.size < totalSize * 1024 * 1024;

        if (!validSize) {
          toast.error(
            `${t.common.file_upload_valid} ${totalSize} ${t.common.file_upload_second}`
          );
          return false;
        }
        return true;
      });

      onFileChange(validFiles, name);
    },
  });
  const t = useSelector(selectTranslations);

  const organisationImage = useSelector((state) => {
    if (state?.auth?.user?.organisation) {
      return state.auth.user.organisation;
    } else {
      return null;
    }
  });
  const selectedLanguage = useSelector((state) => {
    if (state?.i18n?.lang) {
      return state.i18n.lang;
    } else {
      return "en";
    }
  });

  return (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      {name === "image" ? (
        attachments?.image?.name ? (
          <div
            className={`image-dropzone blue-border p-1 file d-flex justify-content-between text-start
          `}
          >
            <div>
              <label className="font14 d-flex align-items-center m-1">
                <div
                  className={`${
                    selectedLanguage == "en" ? "ml-4 mr-4" : "ml-4 mr-4"
                  }`}
                >
                  {fileTypes?.images?.includes(attachments?.image.type) ? (
                    <PngPhotos />
                  ) : (
                    <Mp4File />
                  )}
                </div>

                {attachments?.image?.name}
              </label>
            </div>

            <div
              className="mr-5 ml-5 mt-1 c-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setAttachments({
                  ...attachments,
                  image: null,
                });
              }}
            >
              <CloseIcon width={"18px"} height={"18px"} />
            </div>
          </div>
        ) : (
          <div className="image-dropzone  text-center mb-5">
            <div>
              <p className="p1">
                <div className="d-flex align-items-start justify-content-center ">
                  <div>
                    {" "}
                    <ImgPhotos />
                  </div>
                  <div
                    className={`mr-2 ml-2 ${
                      selectedLanguage == "en" ? "text-left" : "text-right"
                    }`}
                  >
                    {" "}
                    <div className="drag-text"> {t.common.upload_img}</div>{" "}
                    <p className="mb-0 files-text">
                      {" "}
                      {t.common.valid_files_img}
                    </p>{" "}
                  </div>
                </div>
              </p>
            </div>
          </div>
        )
      ) : attachments?.warrantyFile?.name ? (
        <div className="warrenty-file-dropzone text-center">
          <label>
            {attachments?.warrantyFile?.name}
            <span
              className="ml-3 mr-3 c-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setAttachments({
                  ...attachments,
                  warrantyFile: null,
                });
              }}
            >
              <DeleteIcon />
            </span>
          </label>
        </div>
      ) : (
        <div className="warrenty-file-dropzone d-flex align-items-center justify-content-between">
          <div className="d-flex ml-4 mr-4">
            <TextSnippet />
            <div className="pl-4 pr-4">
              <p className="p1 m-0">Warranty file</p>
              <p className="p2 m-0">Attach a file to this asset</p>
            </div>
          </div>
          <div>
            <AddIconWithCircle />
          </div>
        </div>
      )}
    </div>
  );
};

function AddLocation(props) {
  const {
    toggled,
    fromCustomer = false,
    untoggle,
    handleSuccess = () => {},
    refresh,
    setRefresh,
    parentLocation,
    role,
    allIds,
    setParentIds,
    currentUserId,
  } = props;

  const t = useSelector(selectTranslations);
  const selectedLanguage = useSelector((state) => {
    if (state?.i18n?.lang) {
      return state.i18n.lang;
    } else {
      return "en";
    }
  });
  const dispatch = useDispatch();

  const organisationId = useSelector((state) => {
    if (state?.auth?.user?.organisation) {
      return state.auth.user.organisation.id;
    } else {
      return null;
    }
  });

  const [showCancleTooltip, setCancleTooltip] = useState(false);

  const getLocation = () => {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          resolve(position.coords);
        },
        (error) => {
          resolve({});
        }
      );
    });
  };

  const getCountryCodeByName = (countryName) => {
    const country = getCountryByName(countryName);

    if (country) {
      return country.isoCode;
    } else {
      return null;
    }
  };

  /*
   * The function `getData` fetches geocode data from Google Maps API based on latitude and longitude coordinates and resolves with the formatted address.
   */
  function getData(lat, lng) {
    return new Promise((resolve, reject) => {
      fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyDmQtEQpQEGsCaIEgA558XVrMT_bOQFKKM`
      )
        .then(async (response) => {
          return response.json();
        })
        .then(async (result) => {
          setData({
            ...data,
            address: result?.results?.[0]?.formatted_address || "",
          });

          const address = result?.results?.[0]?.formatted_address || "";

          resolve(address);
        });
    });
  }

  const containerStyle = {
    position: "relative",
    width: "100%",
    height: "250px",
  };
  const style = {
    width: "100%",
    height: "100%",
  };

  const [defaultCenter, setDefaultCenter] = useState({
    lat: 0,
    lng: 0,
  });

  useEffect(() => {
    if (toggled) {
      fetchOptions();
    }
    if (toggled && parentLocation) {
      fetchCustomerData();
    }
  }, [toggled]);

  const getLocationData = useCallback(debounce(getData, 800), [defaultCenter]);
  const [attachments, setAttachments] = useState({
    image: null,
    warrantyFile: null,
  });
  const [fetchingCountries, setFetchingCountries] = useState(true);
  const [modalWidth, setModalWidth] = useState(
    Math.max(window.innerWidth / 2, 514)
  );
  const [reloadFlag, setReloadFlags] = useState(true);
  const [initChange, setInitChange] = useState(false);
  const [initView, setInitView] = useState(false);
  const [cancelModal, toggleCancelModal] = useState(false);
  const [buttonStatus, setButtonStatus] = useState(0);
  const [successModal, toggleSuccessModal] = useState(false);
  const { setSuccessModal, SuccessModal } = useSuccessModal();
  const { setNewCancelModal, NewCancelModal } = useNewCancelModal();
  const [mapModal, toggleMapModal] = useState(false);
  const [locationAddedModal, toggleLocationAddedModal] = useState(false);
  const [geofencingModal, toggleGeofencingModal] = useState(false);

  const [geofencingSuccessModal, toggleGeofencingSuccessModal] = useState(
    false
  );

  const [responseData, setResponseData] = useState({});

  const [dropdownOptions, setDropdownOptions] = useState({
    propertyType: [
      {
        key: 0,
        value: "Office Buildings",
        text: t.locations.propertyType.officeBuildings,
      },
      {
        key: 1,
        value: "Industrial Facilities",
        text: t.locations.propertyType.industrialFacilities,
      },
      {
        key: 2,
        value: "Retail Spaces",
        text: t.locations.propertyType.retailSpaces,
      },
      {
        key: 3,
        value: "Educational Institutions",
        text: t.locations.propertyType.educationalInstitutions,
      },
      {
        key: 4,
        value: "Healthcare Facilities",
        text: t.locations.propertyType.healthcareFacilities,
      },
      {
        key: 5,
        value: "Residential Buildings",
        text: t.locations.propertyType.residentialBuildings,
      },
      {
        key: 6,
        value: "Hotels and Hospitality",
        text: t.locations.propertyType.hotelsAndHospitality,
      },
      {
        key: 7,
        value: "Government Buildings",
        text: t.locations.propertyType.governmentBuildings,
      },
      {
        key: 8,
        value: "Data Centers",
        text: t.locations.propertyType.dataCenters,
      },
      {
        key: 9,
        value: "Sports and Recreation Facilities",
        text: t.locations.propertyType.sportsAndRecreationFacilities,
      },
      {
        key: 10,
        value: "Cultural Institutions",
        text: t.locations.propertyType.culturalInstitutions,
      },
      {
        key: 11,
        value: "Transportation Hubs",
        text: t.locations.propertyType.transportationHubs,
      },
      {
        key: 12,
        value: "Laboratories",
        text: t.locations.propertyType.laboratories,
      },
      {
        key: 13,
        value: "Agricultural Facilities",
        text: t.locations.propertyType.agriculturalFacilities,
      },
      {
        key: 14,
        value: "Correctional Facilities",
        text: t.locations.propertyType.correctionalFacilities,
      },
      {
        key: 15,
        value: "Utilities and Energy Facilities",
        text: t.locations.propertyType.utilitiesAndEnergyFacilities,
      },
      {
        key: 16,
        value: "Commercial Parking Structures",
        text: t.locations.propertyType.commercialParkingStructures,
      },
      {
        key: 17,
        value: "Mixed-Use Developments",
        text: t.locations.propertyType.mixedUseDevelopments,
      },
      {
        key: 18,
        value: "Telecommunication Facilities",
        text: t.locations.propertyType.telecommunicationFacilities,
      },
      {
        key: 19,
        value: "Financial Institutions",
        text: t.locations.propertyType.financialInstitutions,
      },
      {
        key: 20,
        value: "Government Housing",
        text: t.locations.propertyType.governmentHousing,
      },
      {
        key: 21,
        value: "Religious Buildings",
        text: t.locations.propertyType.religiousBuildings,
      },
      {
        key: 22,
        value: "Shopping Centers",
        text: t.locations.propertyType.shoppingCenters,
      },
      {
        key: 23,
        value: "Technology and Innovation Hubs",
        text: t.locations.propertyType.technologyAndInnovationHubs,
      },
      {
        key: 24,
        value: "Entertainment Venues",
        text: t.locations.propertyType.entertainmentVenues,
      },
    ],
    parentLocations: [],
    countries: [],
    procedures: [],
    cities: [],
    customers: [],
    vendors: [],
    people: [],
    teams: [],
  });

  const [data, setData] = useState({
    name: "",

    area: [{ area: "" }],
    address: parentLocation?.attributes?.address
      ? parentLocation?.attributes?.address
      : "",
    isParent: false,
    parentLocation: "",
    country: parentLocation?.attributes?.country
      ? parentLocation.attributes.country
      : "",
    city: parentLocation?.attributes?.city
      ? parentLocation.attributes.city
      : "",
    customer: [],
    vendors: [],
    teams: [],
    workers: [],
    mainLocation: {},
    geofencingCoords: [],
    procedure: "",
    propertyType: [],
  });

  const [customFields, setCustomData] = useState([]);
  const [areaFields, setArea] = useState([]);

  const [mapMarker, setMapMarker] = useState({});
  const [geofenceMarkers, setGeofencingCoords] = useState([]);

  const [validation, setValidation] = useState(buildLocationValidation(t));

  const [validForm, setValidForm] = useState(false);
  const getDataSnapshot = useCallback(
      () => ({ ...data, customFields }),
      [data, customFields]
  );

  const onBlur = useMemo(
        () => makeOnBlurFactory({ getData: getDataSnapshot, setValidation }),
    [getDataSnapshot, setValidation]);

  const onValuesChange = useMemo(
      () =>
    makeOnValuesChangeFactory({
          getData: getDataSnapshot,
          setData,
          setValidation,
          setInitChange,
    }),
      [getDataSnapshot, setData, setValidation, setInitChange]);

  const validateOnSubmit = useMemo(
      () => makeValidateOnSubmitFactory({ getData: getDataSnapshot, validation, setValidation }),
  [getDataSnapshot, validation, setValidation]
  );

  /*
   * The `resetForm` function resets various form data and validation states to their initial values.
   */
  const resetForm = () => {
    setData({
      name: "",
      address: "",
      isParent: false,
      parentLocation: "",
      country: "",
      city: "",
      customer: [],
      vendors: [],
      teams: [],
      workers: [],
      mainLocation: {},
      geofencingCoords: [],
      procedure: "",
      propertyType: [],
      area: [{ area: "" }],
    });

    setDefaultCenter({
      lat: 0,
      lng: 0,
    });

    setCustomData([]);
    setCustomFieldErrors([]);
    setArea([]);

    setDropdownOptions({
      ...dropdownOptions,
      parentLocations: [],
      countries: [],
      cities: [],
      customers: [],
      vendors: [],
      users: [],
      teams: [],
    });

    setModalWidth(Math.max(window.innerWidth / 2, 514));

    setValidation(buildLocationValidation(t));

    setValidForm(false);
    setInitChange(false);
  };

  /*
   * The `addNewArea` function adds a new area object with empty values and a default `isStore` value of `false` to the `area` array in the `data` object.
   */
  const addNewArea = () => {
    let areaData = [...data.area];
    areaData.push({ area: "" });
    setData({
      ...data,
      area: areaData,
    });
  };

  /*
   * The function `handleAreaChange` updates the area value at a specific index in the data object and toggles the `isStore` property based on the new value.
   */
  const handleAreaChange = (value, index) => {
    let areaData = [...data.area];
    areaData[index].area = value;

    setData({
      ...data,
      area: areaData,
    });
  };

  const removeArea = (index) => {
    let areaData = [...data.area];
    areaData.splice(index, 1);
    setData({
      ...data,
      area: areaData,
    });
  };

  useEffect(() => {
    const fetchData = State.getStatesOfCountry(data.country);

    if (fetchData.length > 0) {
      let the_options = fetchData.map((el) => {
        return {
          key: el.isoCode,
          value: el.isoCode,
          text: el.name,
        };
      });
      setDropdownOptions({
        ...dropdownOptions,
        cities: the_options,
      });
    } else {
      setDropdownOptions({
        ...dropdownOptions,
        cities: [],
      });
    }
  }, [data.country]);

  const onFileChange = (files, name) => {
    setInitChange(true);
    var randomnumber = Math.floor(Math.random() * (0 - 100 + 1)) + 100;
    setAttachments({
      ...attachments,
      [name]: {
        file: files[0],
        id: randomnumber,
        name: files[0].name,
        type: files[0].type,
        cancelPopup: false,
        isChanged: true,
      },
    });
  };

  useEffect(() => {
    let ele = document.getElementById(`location_1`);

    const AutoAddress = new window.google.maps.places.Autocomplete(ele, {});
    window.google.maps.event.addDomListener(ele, "focus", (e) => {
      e.target.setAttribute("autocomplete", "new-password");
    });

    const handlePlaceSelect = async (e) => {
      const place = AutoAddress.getPlace();

      if (!place.address_components) {
        return;
      }
      const address = extractAddress(place);

      let longitudeData = address.lng;
      let latitudeData = address.lat;
      setDefaultCenter({ lat: latitudeData, lng: longitudeData });

      let the_options = [];

      let city = "";

      if (address?.stateCode?.length > 3) {
        const fetchData = State.getStatesOfCountry(address.countryCode);

        if (fetchData.length > 0) {
          the_options = fetchData.map((el) => {
            return {
              key: el.isoCode,
              value: el.isoCode,
              text: el.name,
            };
          });
        } else {
          the_options = [];
        }

        city = the_options?.find((city) =>
          city?.text?.startsWith(address.stateCode)
        );
      }

      setData((prev) => {
        return {
          ...prev,
          address: address.address3,
          city: city?.value
            ? city.value
            : address.stateCode
            ? address.stateCode
            : "",
          country: address.countryCode ? address.countryCode : "",
        };
      });

      let validcity = city?.value
        ? city.value
        : address.stateCode
        ? address.stateCode
        : "";

      if (validcity.length > 3) {
        setValidation({
          ...validation,
          city: {
            ...validation.city,
            error: true,
          },
        });

        setData((prev) => {
          return {
            ...prev,

            city: "",
          };
        });
      }

      let currentValidationData = cloneDeep(validation);
      if (currentValidationData.address.pattern(address.address1)) {
        currentValidationData.address = {
          ...currentValidationData.address,
          error: false,
          skipped: true,
        };
      } else {
        currentValidationData.address = {
          ...currentValidationData.address,
          error: true,
          skipped: true,
        };
      }

      if (address.countryCode == undefined) {
        currentValidationData.country = {
          ...currentValidationData.country,
          error: true,
          skipped: true,
        };
      } else {
        currentValidationData.country = {
          ...currentValidationData.country,
          error: false,
          skipped: false,
        };
      }

      if (validcity.length > 3) {
        currentValidationData.city = {
          ...currentValidationData.city,
          error: true,
          skipped: true,
        };
      } else {
        currentValidationData.city = {
          ...currentValidationData.country,
          error: false,
          skipped: false,
        };
      }

      setValidation(currentValidationData);
    };

    AutoAddress.addListener("place_changed", handlePlaceSelect);
  }, []);

  const fetchCountriesOptions = () => {
    const countries = Country.getAllCountries();

    if (countries) {
      const _g_options = countries.map((el) => {
        return {
          key: el?.isoCode?.toLowerCase(),
          value: el?.isoCode,
          text: el.name,
          flag: el?.isoCode?.toLowerCase(),
        };
      });

      setDropdownOptions({
        ...dropdownOptions,
        countries: _g_options,
      });
    }
  };

  const fetchParentLocations = async () => {
    const fetchData = await getAllParentLocations(organisationId, "", 1, 99999);
    if (fetchData.response) {
      let the_options = fetchData.response.map((el) => {
        return {
          key: el.id,
          value: el.id,
          text: el.attributes.name,
        };
      });
      setDropdownOptions({
        ...dropdownOptions,
        parentLocations: the_options,
      });
    }
  };

  const fetchCustomerData = async () => {
    const fetchData = await getAllCustomers(organisationId, "", 1, 99999, []);

    if (fetchData.response) {
      let the_options = fetchData.response.map((el) => {
        const the_image = el?.attributes?.logo?.data?.attributes?.url
          ? el?.attributes?.logo?.data?.attributes?.url
          : LetteredAvatarImageUrl(el.attributes.name);
        return {
          key: el.id,
          value: el.id,
          text: el.attributes.name,
          image: { avatar: true, src: the_image, size: "tiny" },
        };
      });
      setDropdownOptions((prev) => {
        return {
          ...prev,
          customers: the_options,
        };
      });
    }
  };

  const fetchVendorsData = async () => {
    const fetchData = await getAllVendros(organisationId);

    if (fetchData.response) {
      let the_options = fetchData.response.map((el) => {
        const the_image = el?.attributes?.logo?.data?.attributes?.url
          ? el?.attributes?.logo?.data?.attributes?.url
          : LetteredAvatarImageUrl(el.attributes.name);
        return {
          key: el.id,
          value: el.id,
          text: el.attributes.name,
          image: { avatar: true, src: the_image, size: "tiny" },
        };
      });
      setDropdownOptions({
        ...dropdownOptions,
        vendors: the_options,
      });
    }
  };

  const generatedCustomDataFields = () => {
    return customFields.map((field, index) => {
      const fieldError = customFieldErrors[index] || { label: "", value: "" };
      return (
        <>
          <div className="custom-container mb-3">
            <label className="custom-label mr-3">
              {t.locations.form.custom_data}
            </label>
          </div>
          <Form.Field>
            <label className="label-item">{t.locations.form.label}</label>
            <Input
              autoComplete="new-password"
              fluid
              placeholder={t.locations.form.label}
              value={field.label}
              onChange={handleCustomDataChange(index, "label")}
              error={!!fieldError.label}
            />
            {fieldError.label && (
                <div className="label-error">{fieldError.label}</div>
            )}
          </Form.Field>

          <Form.Field>
            <label className="label-item">{t.locations.form.value}</label>
            <Input
              autoComplete="new-password"
              fluid
              placeholder={t.locations.form.value}
              value={field.value}
              onChange={handleCustomDataChange(index, "value")}
              error={!!fieldError.value}
            />
            {fieldError.value && (
                <div className="label-error">{fieldError.value}</div>
            )}
          </Form.Field>

          <div
            className="buttun-type-link mb-5"
            basic
            onClick={removeThisData(field.id)}
          >
            {" "}
            <Icon name="trash alternate outline" />
            <p className="ml-2 mr-5 ">{t.common.remove}</p>
          </div>
        </>
      );
    });
  };

  const fetchOptions = async () => {
    const [countries, cities] = await Promise.all([
      Country.getAllCountries(),
      State.getStatesOfCountry(parentLocation?.attributes.country),
    ]);

    if (countries) {
      setFetchingCountries(false);
    }

    setDropdownOptions({
      ...dropdownOptions,
      countries:
        countries?.length > 0
          ? countries.map((el) => {
              return {
                key: el?.isoCode?.toLowerCase(),
                value: el?.isoCode,
                text: el.name,
                flag: el?.isoCode?.toLowerCase(),
              };
            })
          : [],
      cities:
        cities?.length > 0
          ? cities.map((el) => {
              return {
                key: el.isoCode,
                value: el.isoCode,
                text: el.name,
              };
            })
          : [],
    });

    setData((prev) => {
      return {
        ...prev,
        address: parentLocation?.attributes?.address
          ? parentLocation.attributes.address
          : "",
        country: parentLocation?.attributes?.country,
        city: parentLocation?.attributes?.city,
        customer:
          parentLocation?.attributes?.customers?.data?.length > 0
            ? parentLocation?.attributes?.customers?.data?.map((el) => el.id)
            : [],
      };
    });

    setDefaultCenter((prev) => {
      return {
        ...prev,
        lat: parentLocation?.attributes?.mainLocation?.lat
          ? parentLocation?.attributes?.mainLocation?.lat
          : 0,
        lng: parentLocation?.attributes?.mainLocation?.lng
          ? parentLocation?.attributes?.mainLocation?.lng
          : 0,
      };
    });
  };

  const [customFieldErrors, setCustomFieldErrors] = useState([]);

  const isValidCustomField = (field) => {
    const labelValid = !field.label || (field.label.length >= 1 && field.label.length <= 100);
    const valueValid = !field.value || (field.value.length >= 1 && field.value.length <= 255);
    return labelValid && valueValid;
  };

  const addCustomData = () => {
    setCustomData([
      ...customFields,
      {
        label: "",
        value: "",
      },
    ]);
  };

  const addArea = () => {
    setArea([
      ...areaFields,
      {
        label: "",
      },
    ]);
  };

  const removeThisData = (id) => (e) => {
    e.stopPropagation();
    const index = id;
    let newfields = [...customFields];
    newfields.splice(index, 1);

    setCustomData(newfields);
    const newErrors = [...customFieldErrors];
    newErrors.splice(index, 1);
    setCustomFieldErrors(newErrors);
  };

  const handleCustomDataChange = (id, type) => (event) => {
    let newfields = [...customFields];

    let item = { ...customFields[id] };

    if (type == "label") item.label = event.target.value;
    if (type == "value") item.value = event.target.value;
    newfields[id] = item;
    setCustomData(newfields);

    const errors = [...customFieldErrors];
    const labelValid = !item.label || (item.label.length >= 1 && item.label.length <= 100);
    const valueValid = !item.value || (item.value.length >= 1 && item.value.length <= 255);

    errors[id] = {
      label: item.label && !labelValid ? t.common.minmax_chars?.replace("{min}", "1")?.replace("{max}", "100") : "",
      value: item.value && !valueValid ? t.common.minmax_chars?.replace("{min}", "1")?.replace("{max}", "255") : "",
    };

    setCustomFieldErrors(errors);

    setValidation(prev => ({
      ...prev,
      customFields: {
        ...prev.customFields,
        error: !newfields.every(field => isValidCustomField(field)),
        skipped: true,
      }
    }));

  };

  const cancelHandler = () => {
    resetForm();
    setModalWidth(Math.max(window.innerWidth / 2, 514));
    untoggle();
    toggleCancelModal(false);
    setNewCancelModal(false);
    setInitChange(false);
  };

  const submitLocationMarkerHandler = async () => {
    setButtonStatus(1);
    const response = await updateMainLocation(
      responseData.id,
      defaultCenter,
      organisationId
    );

    if (response.status == 200) {
      setButtonStatus(0);

      toggleMapModal(false);
      toggleLocationAddedModal(true);

      setResponseData({
        id: response.data.data.id,
        mainLocation: response.data.data.attributes.mainLocation,
      });
    }
  };

  const submitGeofencingCoordsHandler = async () => {
    setButtonStatus(1);
    const response = await updateGeofencingCoords(
      responseData.id,
      geofenceMarkers
    );
    if (response.status == 200) {
      setButtonStatus(0);
      setSuccessModal(true);
      toggleGeofencingModal(false);
      toggleGeofencingSuccessModal(true);
    }
  };

  const onMarkerDragEnd = async (t, map, coord) => {
    const { latLng } = coord;
    const lat = latLng.lat();
    const lng = latLng.lng();

    setDefaultCenter({ lat, lng });

    let ans = await getData(lat, lng);
    setReloadFlags((pre) => !pre);

    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === "OK") {
        if (results[0]) {
          const addressComponents = results[0].address_components;
          const address = extractAddress(results[0]);

          let the_options = [];

          let city = "";

          if (address?.stateCode?.length > 3) {
            const fetchData = State.getStatesOfCountry(address.countryCode);

            if (fetchData.length > 0) {
              the_options = fetchData.map((el) => {
                return {
                  key: el.isoCode,
                  value: el.isoCode,
                  text: el.name,
                };
              });
            } else {
              the_options = [];
            }

            city = the_options?.find((city) =>
              city?.text?.startsWith(address.stateCode)
            );
          }

          setData({
            ...data,
            address: address.address3,
            city: city?.value
              ? city.value
              : address.stateCode
              ? address.stateCode
              : "",
            country: address.countryCode ? address.countryCode : "",
          });
        } else {
        }
      } else {
      }
    });
  };

  useEffect(() => {
    const validationToArray = Object.entries(validation);
    const cond = validationToArray.some((el) => el[1].error && el[1].skipped);

    if (initChange) setValidForm(!cond);
  }, [validation, initChange]);

  const createNewLocationHandler = async () => {
    const hasErrors = validateOnSubmit();
    if (!hasErrors) {
      setButtonStatus(1);

      const isParentHandler = parentLocation
        ? false
        : data.parentLocation
        ? false
        : true;

      const propertyType = data.propertyType.map((e) => ({
        property: e,
      }));

      const locationImageReponse =
        attachments.image && attachments.image.isChanged
          ? await uploadFile([attachments.image.file])
          : null;

      await createNewLocationHandler2(
        propertyType,
        isParentHandler,
        locationImageReponse?.status == 200
          ? locationImageReponse.data[0].id
          : null
      );

      setButtonStatus(0);
    } else {
      scrollToError();
    }
  };

  const createNewLocationHandler2 = async (
    propertyType,
    isParentHandler,
    image
  ) => {
    const response = await createNewLocation(
      String(data.name),
      String(data.address),
      Boolean(isParentHandler),
      parentLocation
        ? Number(parentLocation?.id)
        : data.parentLocation
        ? Number(data.parentLocation)
        : null,
      String(data.country || 'JO'),
      String(data.city || 'AM'),
      data.customer,
      data.vendors,
      data.teams,
      data.users,
      defaultCenter,
      [defaultCenter] || null,
      customFields,
      organisationId,
      data.procedure ? data.procedure : null,
      currentUserId,
      propertyType,
      parentLocation ? (data?.area?.length > 0 ? data.area : null) : null,
      image
    );

    if (response.status == 200) {
      let Ids = [];
      if (!(role === "super_admin")) {
        Ids = await getParentBySubLoc();
        setParentIds(Ids);
        const userData = await getUserData(currentUserId);
        dispatch(props.fulfillUser(userData));
      }

      setButtonStatus(0);
      untoggle();
      resetForm();
      setResponseData({
        id: response.data.data.id,
        name: response.data.data.attributes.name,
        isParent: response.data.data.attributes.isParent,
      });
      if (fromCustomer) {
        return handleSuccess(response?.data);
      }
      toast.success(
        (response.data.data.attributes.isParent
          ? t.locations.location
          : t.locations.form.sub_location) +
          " " +
          t.common.added_success
      );

      const currentPathname = window.location.pathname;
      if (currentPathname == "/locations-map-view") {
        dispatch(
          fetchAllLoctionData({
            organisationId,
            role,
          })
        );
      } else {
        dispatch(
          fetchLocations({
            organisationId,
            role,
          })
        );
      }
    } else if (response.status == 400) {
      if (response.error && response.error.message) {
        if (
          isParentHandler &&
          response.error.message == "Location name attribute must be unique"
        ) {
          toast.error(t.locations.loc_unique);
        } else if (
          !isParentHandler &&
          response.error.message == "Location name attribute must be unique"
        ) {
          toast.error(t.locations.sub_unique);
        } else {
          toast.error(response.error.message);
        }
      } else {
        toast.error(t.common.something_wrong);
        untoggle();
        resetForm();
      }
    } else {
      toast.error(t.common.something_wrong);
      untoggle();
    }
    setButtonStatus(0);
  };

  const fetchCityData = () => {
    let citiesData = State.getStatesOfCountry(
      parentLocation?.attributes?.country
    );

    setDropdownOptions({
      ...dropdownOptions,
      cities:
        citiesData?.length > 0
          ? citiesData.map((el) => {
              return {
                key: el.isoCode,
                value: el.isoCode,
                text: el.name,
              };
            })
          : [],
    });
  };

  return (
    <>
      <div
        clearing
        style={{ maxWidth: `${modalWidth}px` }}
        className={
          toggled ? "aside-modal active procedure" : "aside-modal procedure"
        }
      >
        <Resizable
          size={{ width: modalWidth, height: "auto" }}
          minWidth={"514px"}
          onResize={(e, direction, ref, d) => {
            setModalWidth(ref.offsetWidth);
          }}
        >
          <div className="modal-header">
            <div className="flexbox justify-between">
              {parentLocation ? (
                <div className="name">{t.locations.form.add_sub_location}</div>
              ) : (
                <div className="name">{t.locations.form.add_location}</div>
              )}
              <div>
                <span
                  className="position-relative c-pointer"
                  onMouseOver={() => setCancleTooltip(true)}
                  onMouseLeave={() => setCancleTooltip(false)}
                  onClick={() =>
                    initChange
                      ? setNewCancelModal(initChange && true)
                      : cancelHandler()
                  }
                >
                  <CloseIcon />
                  <ToolTip
                    color="#fff"
                    backgroundColor="#172B4D"
                    position={
                      selectedLanguage == "en"
                        ? "bottom center"
                        : "bottom center"
                    }
                    arrowAlign="center"
                    show={showCancleTooltip}
                    textBoxWidth="36px"
                    padding="5px 5px 5px 7px"
                    borderRadius="5px"
                    static
                  >
                    <span className="work-order-preview-tooltip">
                      {t.common.close}
                    </span>
                  </ToolTip>
                </span>
              </div>
            </div>
          </div>

          <div className="body">
            {buttonStatus == 1 ? (
              <Dimmer active inverted>
                <Loader inverted content="Loading" />
              </Dimmer>
            ) : (
              ""
            )}

            <FileUpload
              onFileChange={onFileChange}
              name="image"
              attachments={attachments}
              setAttachments={setAttachments}
            />

            {parentLocation ? (
              <Form.Field>
                <label className="label-item mt-5">
                  {t.locations.form.parent_location}
                </label>
                <Input
                  fluid
                  value={`${parentLocation?.attributes?.name} [#${parentLocation?.id}]`}
                  disabled
                />
              </Form.Field>
            ) : null}
            <Form.Field>
              <label className={`label-item ${parentLocation ? "" : "mt-5"}`}>
                {parentLocation
                  ? t.locations.form.sub_location_name
                  : t.locations.form.location_name}
                <Asterisk color="#172B4D" />
              </label>
              <Input
                autoComplete="new-password"
                fluid
                placeholder={
                  parentLocation
                    ? t.locations.form.enter_sub_location_name
                    : t.locations.form.enter_location_name
                }
                value={data.name}
                onChange={onValuesChange("name")}
                error={validation.name.error && validation.name.skipped}
                onBlur={onBlur("name")}
              />
              {validation.name.error && validation.name.skipped ? (
                <div className="label-error">{validation.name.message}</div>
              ) : (
                ""
              )}
            </Form.Field>

            <Form.Field>
              <label className="label-item">
                {t.locations.table.address}
                <Asterisk color="#172B4D" />
              </label>
              <div>
                <Input
                  type="text"
                  id="location_1"
                  autoComplete="new-password"
                  className={
                    selectedLanguage == "en"
                      ? "location-address"
                      : "location-address-rtl"
                  }
                  fluid
                  placeholder={t.locations.form.address_placeholder}
                  value={data.address}
                  onChange={(e) => {
                    setDefaultCenter({ lat: 0, lng: 0 });
                    setData({
                      ...data,
                      address: e.target.value,
                    });

                    setInitView(true);
                  }}
                  error={validation.address.error && validation.address.skipped}
                  onBlur={onBlur("address")}
                />
                {!data.address ? (
                  <img
                    className="date-picker-image location"
                    // style={{ top: "-26px", left: "8px" }}
                    src={search_icon}
                  />
                ) : null}
              </div>
              {validation.address.error && validation.address.skipped ? (
                <div
                  // style={!data?.address ? { marginTop: "-15px" } : {}}
                  className={`label-error ${!data?.address ? "error" : ""}`}
                >
                  {validation.address.message}
                </div>
              ) : (
                ""
              )}
            </Form.Field>
            {defaultCenter.lat && defaultCenter.lng ? (
              <div>
                <Map
                  google={window.google}
                  style={style}
                  containerStyle={containerStyle}
                  center={defaultCenter}
                  initialCenter={defaultCenter}
                  version="weekly"
                >
                  <Marker
                    position={defaultCenter}
                    draggable={true}
                    icon={{
                      url: CustomMarkerIcon,
                      scaledSize: new window.google.maps.Size(35, 35),
                    }}
                    onDragend={(t, map, coord) =>
                      onMarkerDragEnd(t, map, coord)
                    }
                  />
                </Map>
              </div>
            ) : null}

            {data.isParent ? (
              <Form.Field>
                <label className="label-item">
                  {t.locations.form.parent_location}
                  <Asterisk color="#172B4D" />
                </label>
                <Dropdown
                  placeholder="Choose from existing Location"
                  fluid
                  noResultsMessage={t.common.no_results_found}
                  search
                  selection
                  clearable
                  options={dropdownOptions.parentLocations}
                  value={data.parentLocation}
                  onChange={onValuesChange("parentLocation")}
                  onOpen={() => fetchParentLocations()}
                  error={
                    validation.parentLocation.error &&
                    validation.parentLocation.skipped
                  }
                  onBlur={onBlur("parentLocation", (d) => (d.isParent ? d.parentLocation : null))}
                />
                {validation.parentLocation.error &&
                validation.parentLocation.skipped ? (
                  <div className="label-error">
                    {validation.parentLocation.message}
                  </div>
                ) : (
                  ""
                )}
              </Form.Field>
            ) : (
              ""
            )}

            <Form.Field autoComplete="off">
              <label
                className={`label-item ${
                  defaultCenter.lat && defaultCenter.lng ? "mt-5" : ""
                }`}
              >
                {t.locations.table.country}
                <Asterisk color="#172B4D" />
              </label>
              <Dropdown
                placeholder={t.locations.form.country_add}
                noResultsMessage={t.common.no_results_found}
                fluid
                clearable
                search
                selection
                options={dropdownOptions.countries}
                value={data.country}
                disabled={
                  data.country !== "AX" && (data?.country || fetchingCountries)
                    ? true
                    : false
                }
                onChange={onValuesChange("country")}
                loading={fetchingCountries}
                onOpen={fetchCountriesOptions}
                error={validation.country.error && validation.country.skipped}
                onBlur={onBlur("country")}
              />
              {validation.country.error && validation.country.skipped ? (
                <div className="label-error">{validation.country.message}</div>
              ) : (
                ""
              )}
            </Form.Field>
            <Form.Field autoComplete="off">
              <label className="label-item">
                {t.locations.table.city}
                <Asterisk color="#172B4D" />
              </label>
              <Dropdown
                placeholder={t.locations.form.city_add}
                noResultsMessage={t.common.no_results_found}
                fluid
                clearable
                search
                selection
                options={dropdownOptions.cities}
                disabled={data?.city ? true : false}
                value={data.city}
                onChange={onValuesChange("city")}
                error={validation.city.error && validation.city.skipped}
                onBlur={onBlur("city")}
              />
              {validation.city.error && validation.city.skipped ? (
                <div className="label-error">{validation.city.message}</div>
              ) : (
                ""
              )}
            </Form.Field>

            {parentLocation && data.area.length > 0 ? (
              <label className="label-item">{t.assets.form.area}</label>
            ) : null}

            {parentLocation &&
              data.area.map((one, index) => {
                return (
                  <>
                    <div className="flexbox area-container mt-3">
                      <Input
                        className="area-input-div flex-grow-1"
                        placeholder={t.assets.form.add_area}
                        type="text"
                        fluid
                        selection
                        value={one.area}
                        onChange={(e) =>
                          handleAreaChange(e.target.value, index)
                        }
                      />

                      {
                        <span
                          className="delete-area ml-2 mr-2 p-1 d-flex align-items-center justify-content-center c-pointer"
                          onClick={() => {
                            removeArea(index);
                          }}
                          // style={{ backgroundColor: "#E9F2FF" }}
                        >
                          <DeleteIcon fill={"#0C66E4"} />
                        </span>
                      }
                    </div>
                  </>
                );
              })}
            {parentLocation && (
              <div
                className={`buttun-type-link ${
                  data.area.length > 0 ? "mt-5" : " "
                }`}
                basic
                onClick={addNewArea}
              >
                <span className="customer-add-btn">
                  {" "}
                  <CustomerPlusIcon />{" "}
                </span>

                <p className={selectedLanguage == "en" ? "ml-2" : "mr-2"}>
                  {t.assets.form.add_area}
                </p>
              </div>
            )}

            <Form.Field autoComplete="off ">
              <label
                className={!parentLocation ? "label-item" : "label-item mt-5"}
              >
                {t.locations.form.propertyType}
              </label>
              <Dropdown
                placeholder={t.locations.form.select_propertyType}
                noResultsMessage={t.common.no_results_found}
                fluid
                search
                selection
                multiple
                options={dropdownOptions.propertyType}
                value={data.propertyType}
                onChange={onValuesChange("propertyType")}
              />
            </Form.Field>

            <Form.Field>
              <label className="label-item">{t.locations.table.customer}</label>
              <Dropdown
                placeholder={t.locations.form.select_customer}
                noResultsMessage={t.common.no_results_found}
                fluid
                search
                selection
                multiple
                options={dropdownOptions.customers}
                value={data.customer}
                onChange={onValuesChange("customer")}
                onOpen={() => fetchCustomerData()}
                error={validation.customer.error && validation.customer.skipped}
                onBlur={(e) => {
                  if (validation.customer.pattern(data.customer)) {
                    setValidation({
                      ...validation,
                      customer: {
                        ...validation.customer,
                        error: false,
                        skipped: true,
                      },
                    });
                  } else {
                    setValidation({
                      ...validation,
                      customer: {
                        ...validation.customer,
                        error: true,
                        skipped: true,
                      },
                    });
                  }
                }}
              />
              {validation.customer.error && validation.customer.skipped ? (
                <div className="label-error">{validation.customer.message}</div>
              ) : (
                ""
              )}
            </Form.Field>

            <Form.Field>
              <label className="label-item">{t.locations.form.vendors}</label>
              <Dropdown
                placeholder={t.locations.form.select_vendors}
                noResultsMessage={t.common.no_results_found}
                fluid
                search
                multiple
                selection
                options={dropdownOptions.vendors}
                value={data.vendors}
                onChange={onValuesChange("vendors")}
                onOpen={() => fetchVendorsData()}
              />
            </Form.Field>

            {generatedCustomDataFields()}
            <div className="buttun-type-link" basic onClick={addCustomData}>
              <span className="customer-add-btn">
                {" "}
                <CustomerPlusIcon />{" "}
              </span>

              <p className={selectedLanguage == "en" ? "ml-2" : "mr-2"}>
                {t.locations.form.custom_data}
              </p>
            </div>

            <div className="form-button-container">
              <button
                onClick={() =>
                  initChange
                    ? setNewCancelModal(initChange && true)
                    : cancelHandler()
                }
                className="form-action-button"
              >
                {t.common.cancel}
              </button>

              <button
                onClick={createNewLocationHandler}
                className="form-action-button blue"
                disabled={buttonStatus == 1}
              >
                {t.common.submit}
              </button>
            </div>
          </div>
        </Resizable>
      </div>
      <div
        className={
          toggled ? "aside-modal-background active" : "aside-modal-background"
        }
        onClick={() =>
          initChange ? setNewCancelModal(initChange && true) : cancelHandler()
        }
      ></div>
      {/* success modal */}
      <Modal
        size="tiny"
        className="assets-modal"
        open={successModal}
        onClose={() => {
          toggleSuccessModal(false);
          setRefresh(!refresh);
        }}
      >
        <div className="text-right mt-5 mr-5">
          <span
            className="c-pointer"
            onClick={() => {
              toggleSuccessModal(false);
              setRefresh(!refresh);
            }}
          >
            <CloseIcon />
          </span>
        </div>

        <Modal.Content>
          <div className="text-center">
            <div className="mb-5">
              <Success />
            </div>
            <p className="status-modal-popup-message">
              {t.locations.location} <b>{responseData.name}</b>{" "}
              {t.common.added_success}
            </p>
            {responseData.isParent ? (
              <p className="status-modal-popup-message">
                {t.locations.add_location_on_map_statement}
              </p>
            ) : null}
          </div>
        </Modal.Content>

        <div className="modal-button-container justify-content-center">
          {responseData.isParent ? (
            <>
              <button
                onClick={() => {
                  toggleSuccessModal(false);
                  setRefresh(!refresh);
                }}
                className="modal-form-action-button "
              >
                {t.common.later}
              </button>

              <button
                onClick={() => {
                  toggleSuccessModal(false);
                  toggleMapModal(true);
                }}
                className="modal-form-action-button blue"
              >
                {t.locations.add_on_map}
              </button>
            </>
          ) : (
            <Modal.Actions>
              <Button
                color="black"
                className="button-transparent"
                onClick={() => {
                  toggleSuccessModal(false);
                  setRefresh(!refresh);
                }}
              >
                {t.common.ok}
              </Button>
            </Modal.Actions>
          )}
        </div>
      </Modal>

      {/* ask if you want to add location on map modal */}
      <Modal
        size="tiny"
        open={mapModal}
        className="assets-modal"
        onClose={() => {
          toggleMapModal(false);
          setRefresh(!refresh);
        }}
      >
        <div className="header-container">
          <span className="assets-header">
            {t.locations.add_location_on_map}
          </span>

          <div>
            <span
              className="c-pointer text-right"
              onClick={() => {
                toggleMapModal(false);
                setRefresh(!refresh);
              }}
            >
              <CloseIcon />
            </span>
          </div>
        </div>

        <Modal.Content>
          <p>{t.locations.drag_marker_statement}</p>
          <MapMarker
            locationName={responseData.name}
            submitMarker={setMapMarker}
          />
        </Modal.Content>

        <div className="modal-button-container justify-content-center">
          <button
            onClick={() => {
              toggleMapModal(false);
              setRefresh(!refresh);
            }}
            className="modal-form-action-button "
          >
            {t.common.later}
          </button>

          <button
            onClick={() => {
              submitLocationMarkerHandler();
            }}
            className="modal-form-action-button blue"
          >
            {t.locations.add_on_map}
          </button>
        </div>
      </Modal>

      {/* success add location on map modal */}
      <Modal
        size="tiny"
        open={locationAddedModal}
        className="assets-modal"
        onClose={() => {
          toggleLocationAddedModal(false);
          setRefresh(!refresh);
        }}
      >
        <div className="text-right mt-5 mr-5">
          <span
            className="c-pointer"
            onClick={() => {
              toggleLocationAddedModal(false);
              setRefresh(!refresh);
            }}
          >
            <CloseIcon />
          </span>
        </div>
        <Modal.Content>
          <div className="text-center">
            <div className="mb-5">
              <GreenLocationIcon />
            </div>
            <p className="status-modal-popup-message">
              {t.locations.location_added_on_map_success}
            </p>
            <p className="status-modal-popup-message">
              {t.locations.add_geo_coord_statement}
            </p>
          </div>
        </Modal.Content>

        <div className="modal-button-container justify-content-center">
          <button
            onClick={() => {
              toggleLocationAddedModal(false);
              setRefresh(!refresh);
            }}
            className="modal-form-action-button "
          >
            {t.common.later}
          </button>

          <button
            onClick={() => {
              toggleLocationAddedModal(false);
              toggleGeofencingModal(true);
            }}
            className="modal-form-action-button blue"
          >
            {t.locations.add_on_map}
          </button>
        </div>
      </Modal>

      {/* ask if you want to add geofencing coords on map modal */}
      <Modal
        size="tiny"
        className="assets-modal"
        open={geofencingModal}
        onClose={() => {
          toggleGeofencingModal(false);
          setRefresh(!refresh);
        }}
      >
        <div className="header-container">
          <span className="assets-header">{t.locations.add_geo_coord}</span>

          <div>
            <span
              className="c-pointer text-right"
              onClose={() => {
                toggleGeofencingModal(false);
                setRefresh(!refresh);
              }}
            >
              <CloseIcon />
            </span>
          </div>
        </div>

        <Modal.Content>
          <p>{t.locations.click_to_add_coord}</p>
          {geofencingModal ? (
            <GeofenceMarker
              center_map={responseData.mainLocation}
              submitMarker={setGeofencingCoords}
            />
          ) : (
            ""
          )}
        </Modal.Content>

        <div className="modal-button-container justify-content-center">
          <button
            onClick={() => {
              toggleGeofencingModal(false);
              setRefresh(!refresh);
            }}
            className="modal-form-action-button "
          >
            {t.common.later}
          </button>

          <button
            onClick={() => {
              submitGeofencingCoordsHandler();
            }}
            className="modal-form-action-button blue"
          >
            {t.locations.add_on_map}
          </button>
        </div>
      </Modal>

      <Modal
        size="tiny"
        className="assets-modal"
        open={geofencingSuccessModal}
        onClose={() => {
          toggleGeofencingSuccessModal(false);
          setRefresh(!refresh);
        }}
      >
        <div className="text-right mt-5 mr-5">
          <span
            className="c-pointer"
            onClick={() => {
              toggleGeofencingSuccessModal(false);
              setRefresh(!refresh);
            }}
          >
            <CloseIcon />
          </span>
        </div>
        <Modal.Content className="pt-0">
          <div className="text-center">
            <div className="mb-5">
              <GreenLocationIcon />
            </div>
            <p className="status-modal-popup-message">
              {t.locations.geo_add_success}
            </p>
          </div>
        </Modal.Content>

        <Modal.Actions>
          <Button
            color="black"
            className="button-transparent"
            onClick={() => {
              toggleGeofencingSuccessModal(false);
              setRefresh(!refresh);
            }}
          >
            {t.common.ok}
          </Button>
        </Modal.Actions>
      </Modal>

      <NewCancelModal
        yesCallback={() => {
          cancelHandler();
        }}
        title={t.parts.form.changes}
      >
        <p className="cancel-child"> {t.common.cancel_2statement}</p>
      </NewCancelModal>
    </>
  );
}

AddLocation.defaultProps = {
  parentLocation: null,
  refresh: null,
  setRefresh: () => {},
  untoggle: () => {},
  toggled: null,
};

export default connect(null, auth.actions)(AddLocation);
